import React, { useState, useEffect } from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import PersonIcon from '@mui/icons-material/Person';
import IconButton from '@mui/material/IconButton';
import AccountCircleTwoToneIcon from '@mui/icons-material/AccountCircleTwoTone';
import { getInfo , logout } from '../../services/driver';
const style = {
    position: 'absolute',
    top: '30%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 300,
    bgcolor: 'background.paper',
    border: 'none',
    borderRadius: 5,
    boxShadow: 24,
    p: 4,
    textAlign: 'center',

};

export default function UserModal(props) {
    const { handleOpen, handleClose, open } = props;
    const [dataa, setData] = useState(null);
    const getData = async (e) => {
        // try {
        const { data } = await getInfo();
        setData(data?.data?.user)
    }
    const Logout = async (e) => {
        window.open('/' , '_self')
    }
    useEffect(() => {
        getData();

    }, [])
    return (
        <div>
            <IconButton onClick={handleOpen}>
                <PersonIcon color='gray'/>
            </IconButton>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <Box sx={style}>
                        <AccountCircleTwoToneIcon sx={{ width: 120, height: 150 }} />
                        {dataa ?
                            <>
                                <Typography id="transition-modal-title" variant="h6" component="h2"  sx={{fontFamily: 'SansX'}}>
                                    {dataa.full_name}&nbsp; &nbsp;
                                </Typography>
                                {dataa.wallet_balance !== null ?
                                <Typography id="transition-modal-description" sx={{ mt: 2, fontFamily: 'SansX', marginBottom: '10px' }}>
                                    شماره تماس:{dataa.phone}
                                </Typography>: null}
                            </>
                            : null}
                            <Button
                            onClick={()=> window.open('history' ,'_self')}
                            color='info'
                            sx={{ fontFamily: 'SansX', marginTop: "1vh", margin: '2vh' }}
                            variant="outlined" >
                            مشاهده لیست سفرهای انجام شده
                        </Button>
                        <Button
                            onClick={Logout}
                            color='error'
                            sx={{ fontFamily: 'SansX', margin: '1vh' }}
                            variant="outlined" >
                            خروج
                        </Button>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
}
